import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CommonService } from "../../../services/common/common.service";
import SettingsHead from "../../../modules/settings/shared/settings-head/settings-head.component";
import { Box } from "@material-ui/core";
import { GlobalContext } from "../../../store";
import DataExchangeContentComponent from "../../../modules/settings/components/data-exchange/data-exchange-content.component";
import SupportBlockComponent from "../../../components/support/support.component";

export default function DataExchangePage(props: any) {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.DATA_EXCHANGE"));
      setPageTitle(t("PAGE_META_TITLES.DATA_EXCHANGE"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="content">
      <SettingsHead
        title={t("PAGES_HEAD.SETTINGS.SECURE_DATA_EXCHANGE_TITLE")}
        subTitle={t("PAGES_HEAD.SETTINGS.SECURE_DATA_EXCHANGE_SUB_TITLE")}
      />
      <DataExchangeContentComponent />
      <SupportBlockComponent />
    </Box>
  );
}
